<div class="w-full px-4">
  <p-toast></p-toast>

  <div class="w-full flex flex-column gap-3">
    <div class="grid align-items-center">
      <h1 class="text-left col-8 font-bold text-4xl">My Students</h1>
      <div class="col-4 flex justify-content-end">
        <p-button [icon]="showFilters ? 'pi pi-filter-slash' : 'pi pi-filter'"
          [label]="showFilters ? 'Hide Filters' : 'Show Filters'" (click)="toggleFilters()" styleClass="submitBtn" />
      </div>
    </div>

    <div *ngIf="showFilters" class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
      <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
      <form [formGroup]="filterForm" (ngSubmit)="onFilter()" class="w-full flex flex-wrap">
        <div class="w-full grid">
          <div class="col-12 sm:col-6 md:col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Student Name</b>
            <input pInputText type="text" formControlName="studentName" placeholder="Student Name" class="w-full" />
          </div>
          <div class="col-12 sm:col-6 md:col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Student Email</b>
            <input pInputText type="text" formControlName="studentEmail" placeholder="Student Email" class="w-full" />
          </div>
          <div class="col-12 sm:col-6 md:col-2 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Package</b>
            <p-dropdown [options]="packages" formControlName="packageId" optionLabel="name" optionValue="id"
              [showClear]="true" [filter]="true" filterBy="name" appendTo="body" placeholder="All Packages"
              styleClass="selectFull" class="w-full">
            </p-dropdown>
          </div>
          <div class="col-12 sm:col-6 md:col-2 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">Purchase Date</b>
            <p-calendar formControlName="dateRange" selectionMode="range" [showIcon]="true" dateFormat="dd/mm/yy"
              appendTo="body" placeholder="Date range" styleClass="fullWidth" class="w-full">
            </p-calendar>
          </div>
          <div class="col-12 sm:col-6 md:col-2 flex align-items-end gap-2">
            <div class="w-full">
              <p-button type="submit" label="Search" class="w-full" styleClass="submitBtn" />
            </div>
            <div class="w-full">
              <p-button type="button" label="Clear" (click)="clearAllFilters()" class="w-full"
                styleClass="p-button-outlined clearBtn" />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="w-full">
      <p-table *ngIf="students && students.length > 0; else noRecordsFound" [value]="students"
        [paginator]="true" [alwaysShowPaginator]="true" [rows]="rowSize" [totalRecords]="totalRecords" [first]="first"
        [lazy]="true" [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'"
        [showCurrentPageReport]="true" (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 25, 50]"
        [showPageLinks]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Student Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Package</th>
            <th>Mentor</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-student>
          <tr>
            <td>{{ student.studentName }}</td>
            <td>{{ student.studentEmail }}</td>
            <td>{{ student.studentPhoneNumber || '-' }}</td>
            <td>{{ student.packageName || '-' }}</td>
            <td>{{ student.mentorName || '-' }}</td>
            <td>
              <div class="flex align-items-center justify-content-center gap-2">
                <p-button icon="pi pi-folder-open" label="Documents" styleClass="viewapplication"
                  (click)="viewDocuments(student.studentId)" pTooltip="Documents" tooltipPosition="top" />
                <p-button icon="pi pi-user" label="Profile" styleClass="viewapplication"
                  (click)="viewProfile(student.studentId)" pTooltip="Profile" tooltipPosition="top" />
                <p-button icon="pi pi-file-edit" label="Applications" styleClass="viewapplication"
                  (click)="viewApplications(student.studentId)" pTooltip="Applications" tooltipPosition="top" />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>
